export default __webpack_public_path__ + "static/media/LogoGhsh.ca947e14.svg";